<!-- Нижнее окно: выезд, свайп вниз, затемнение — SheetDirective -->
<div class="drink-dialog-container" [appSheet]="scrollContent" (sheetClosed)="onSheetClosed()">

  <!-- Ручка: окно закрывается свайпом вниз -->
  <div class="sheet-grabber"></div>

  <div mat-icon-button (click)="close(); $event.stopPropagation()" class="close-button">
    <mat-icon class="close-icon">close</mat-icon>
  </div>

  <div class="drink-dialog-title__header">
    <p>{{ drink | fieldTranslate: 'title' }}</p>
  </div>

  <div class="drink-dialog-content" #scrollContent [class.with-order]="canOrder">

    <!-- Изображение напитка -->
    <div class="image-container">

      <img class="drink-dialog-image" mat-card-image [src]="imageSrc" [class.no-photo]="noPhoto" loading="eager" decoding="async"
        alt="Photo of the drink" />
      <!-- Маркеры — как на карточке в списке; ниже крестика -->
      <app-label-banners class="dialog-banners" [labels]="data.labels"></app-label-banners>
    </div>

    <!-- Наименование напитка -->
    <div class="drink-dialog-title__container" #titleOriginal>
      <div class="drink-dialog-title">{{ drink | fieldTranslate: 'title' }}</div>
    </div>

    <!-- Описание — сразу под названием: сначала о напитке, потом цифры и аллергены -->
    <div class="drink-dialog-description" *ngIf="drink | fieldTranslate: 'description' as description">{{ description }}</div>

    <!-- Price -->
    <div class="drink-dialog-info">
      <div class="drink-dialog-info__price" *ngIf="drink.price as value">
        <ng-container *ngIf="value | priceSeparator as separated">
          <span class="drink-dialog-info__price__whole">{{ separated.whole }}</span>
          <span class="drink-dialog-info__price__dot">{{ separated.separator }}</span>
          <span class="drink-dialog-info__price__fraction">{{ separated.fraction }}</span>
          <span class="drink-dialog-info__price__currency">{{ locale?.currency }}</span>
        </ng-container>
      </div>

      <!-- Объём и время приготовления -->
      <div class="drink-dialog-info__size" *ngIf="drink.size">{{ localSize }} {{ locale?.units?.get(data.unit) }}</div>
      <div class="drink-dialog-info__kkal" *ngIf="kkal">{{ roundedKkal }} {{ 'kkal' | translate }}</div>
      <div class="drink-dialog-info__time" *ngIf="data.prepare">{{ data.prepare }} {{ locale?.time }}</div>

      <!-- Энергетическая ценность — в конце строки цифр, у правого края -->
      <img *ngIf="data.kkal || data.fats || data.carbs || data.proteins"
        src="assets/info.svg"
        alt="info"
        class="drink-dialog-button"
        (click)="toggleInfo(); $event.stopPropagation()"
      />
    </div>

    <!-- Энергетическая ценность (по кнопке информации) — над аллергенами, в их стиле -->
    <div class="drink-dialog-info__energy-wrap" *ngIf="isInfoVisible"
     [@slideToggle]>
      <div *ngIf="data.kkal || data.fats || data.carbs || data.proteins" class="drink-dialog-info__energy">
        <div class="drink-dialog-info__energy__title">{{ 'energy' | translate }} ({{ data.energy ? '100 ' +
          (locale?.units?.get(data.unit) || 'ml') : 'drink' | translate }})</div>
        <div class="drink-dialog-info__energy__values">
          <div class="drink-dialog-info__energy__value" *ngIf="data.fats">{{ 'fats' | translate }}: {{ data.fats }}</div>
          <div class="drink-dialog-info__energy__value" *ngIf="data.carbs">{{ 'carbs' | translate }}: {{ data.carbs }}</div>
          <div class="drink-dialog-info__energy__value" *ngIf="data.proteins">{{ 'protein' | translate }}: {{ data.proteins }}</div>
        </div>
      </div>
    </div>

    <!-- Аллергены — сразу, без кнопки информации -->
    <app-allergen-list [allergens]="data.allergens"></app-allergen-list>

    <!-- Варианты напитка -->
    <div *ngIf="data.variability && data.variants.length">
      <app-menu-dialog-drink-variants [drink]="data"
        (variantsChange)="onVariantsChange()"></app-menu-dialog-drink-variants>
    </div>

    <!-- Grid модификаторов -->
    <app-menu-modificators-grid *ngIf="modificators && modificators.items?.length" [modificators]="modificators"
      (modificatorsChange)="onModificatorsChange()">
    </app-menu-modificators-grid>

    <!-- Рекомендации -->
    <app-menu-recomendations *ngIf="data.recomendations.length" [recomendations]="data.recomendations">
    </app-menu-recomendations>
  </div>

  <!-- Кнопки для заказа — только со столом (без стола меню только для просмотра).
       Часть окна, а не экрана: едут вместе с ним при свайпе -->
  <div class="drink-dialog-order" *ngIf="canOrder">

    <!-- Блок управления количеством -->
    <div class="order-quantity">
      <button class="bascket-count-dec" (click)="decrement(); $event.stopPropagation()"
        [ngStyle]="{'color': drink.count > 1 ? '#000000' : '#9e9e9e'}">−</button>
      <div class="order-button__count">{{ drink.count }}</div>
      <button class="bascket-count-inc" (click)="increment(); $event.stopPropagation()">+</button>
    </div>

    <!-- Кнопка добавления в корзину -->
    <button class="basket-button" (click)="buttonPushRemoveDrinkBasket(); $event.stopPropagation()"
      [ngStyle]="{'color': isBasket && !canUpdate ? 'red' : 'black'}" *ngIf="drink.totalPrice * drink.count as value">
      <span *ngIf="!isBasket">{{ 'add' | translate }}</span>
      <span *ngIf="isBasket && !canUpdate">{{ 'remove' | translate }}</span>
      <span *ngIf="isBasket && canUpdate">{{ 'update' | translate }}</span>
      <ng-container *ngIf="value | priceSeparator as separated">
        <span class="basket-button__whole">{{ separated.whole }}</span>
        <span class="basket-button__dot">{{ separated.separator }}</span>
        <span class="basket-button__fraction">{{ separated.fraction }}</span>
        <span class="basket-button__currency">{{ locale?.currency }}</span>
      </ng-container>
    </button>
  </div>
</div>
